import React from 'react';
import { Divider, Flex, HStack } from '@chakra-ui/react';
import StandardModal from '../Modal/StandardModal';
import EPCChart from './EPCChart';
import { energyRatingChartConfig, environmentImpactChartConfig, } from '../../../constants/EpcChartsConfig';
import { useTokens } from '../../../context/TokenProvider';
import { localise } from '../../../services/lang/lang';
const EpcModal = ({ epc, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(StandardModal, { "data-testid": "epc_modal", variant: "primary-large", title: localise('EPC'), ...rest },
        React.createElement(HStack, { pt: tokens.Spacing07, w: "100%" },
            React.createElement(EPCChart, { title: localise('ENERGY_EFFICIENCY_RATING'), bands: energyRatingChartConfig, current: epc?.current_energy_rating, potential: epc?.potential_energy_rating, "data-testid": "epc_chart__energy" }),
            React.createElement(Flex, null,
                React.createElement(Divider, { variant: "grey", orientation: "vertical", my: tokens.Spacing02 })),
            React.createElement(EPCChart, { title: localise('ENVIRONMENTAL_IMPACT_RATING'), bands: environmentImpactChartConfig, current: epc?.environment_impact_current, potential: epc?.environment_impact_potential, "data-testid": "epc_chart__environmental" }))));
};
export default EpcModal;
